'use strict';

const React = require('react');
const ReactDOM = require('react-dom');
const Relay = require('react-relay');
const { Provider } = require('react-redux');
const { combineReducers, createStore, applyMiddleware } = require('redux');
const { NetPriceModal, ModalWrapper, reducers } = require('dibs-contact-modal');
const { fields, modalWrapper, tracking, validation } = reducers;
const store = createStore(
    combineReducers({ fields, modalWrapper, tracking, validation }),
    applyMiddleware(require('redux-thunk').default)
);
const { track } = require('../../../global/utils/social/chat');

const modalContainer = document.createElement('div');
const { getUserId, cookieJarConstants } = require('dibs-cookie-jar');
const { getEnvironment } = require('../../../global/relayEnvironmnentProvider.es').default;

module.exports = options => {
    const {
        item,
        itemPk,
        currency,
        linkLocation
    } = options;

    const sellerId = item.get('seller.id');
    const userId = getUserId(document.cookie, cookieJarConstants.MASQUERADE_BUYER);

    const queryConfig = {
        queries: {
            viewer: (Component, params) => Relay.QL`
                query {
                    viewer {
                        ${Component.getFragment('viewer', params)}
                    }
                }
            `
        },
        name: 'NetPriceModalRoute',
        params: {
            userId,
            sellerId,
            itemId: itemPk,
            shouldFetchItem: !!itemPk,
            shouldFetchUser: !!userId,
            shouldFetchBuyerItemConv: !!itemPk && !!userId
        }
    };

    ReactDOM.render(
        <Provider store={ store }>
            <Relay.Renderer
                Container={ NetPriceModal }
                environment={ getEnvironment() }
                queryConfig={ queryConfig }
                render={({done, error, props}) => {
                    if (error) {
                        return (
                            <ModalWrapper
                                openOnRender
                                isError
                            />
                        );
                    } else if (done && props) {
                        const netPriceProps = Object.assign({}, props, {
                            chatTracking: track,
                            currency,
                            linkLocation
                        });
                        return (
                            <NetPriceModal {...netPriceProps} />
                        );
                    } else {
                        return (
                            <ModalWrapper
                                openOnRender
                                isLoading
                            />
                        );
                    }
                }}
            />
        </Provider>,
        modalContainer
    );
};



// WEBPACK FOOTER //
// ./assets/js/contact/netPrice/helpers/netPriceLauncher.jsx